import React from 'react';
import { Tooltip, IconButton, Icon, Popover, Box } from '@material-ui/core';

import { PrettyJsonString } from '../elements';
import { HealthInjectorVersion } from '../models/device';

export interface VersionPopoverProps {
  version: HealthInjectorVersion;
  id: string;
  title: string;
}

function VersionPopover({ version, id, title }: VersionPopoverProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Tooltip arrow title={title}>
        <IconButton color="primary" onClick={handleClick}>
          <Icon>{'linear_scale'}</Icon>
        </IconButton>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
      >
        <Box margin={1}>
          <PrettyJsonString data={JSON.stringify(version)} />
        </Box>
      </Popover>
    </div>
  );
}

export default VersionPopover;
